import {axios as http} from "@/plugins/http";

export default class Api {
    static categories() {
        return http.get('/api/v1/catalog/list')
    }

    static categoryInfo(categoryId) {
        return http.post("/api/v1/post/mark-ad-auto/category-info", {
            "category_id": categoryId,
        }).then((resp) => {
            return resp.data
        })
    }

    static categoryKktu(code) {
        return http.post("/api/v1/post/mark-ad-auto/category-kktu", {
            "code": code,
        }).then((resp) => {
            return resp.data
        })
    }
}
